var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-wrapper"},[(_vm.owners_association)?_c('Votations',{attrs:{"owners_association":_vm.owners_association}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }